import { Component, Inject } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';
import { MatDialogModule, MAT_DIALOG_DATA } from '@angular/material/dialog';
import { ConfirmDialogData } from '@app/common/components/confirm-dialog/confirm-dialog-data';
import { TranslateModule } from '@ngx-translate/core';
import { FlowbiteButtonComponent } from '../flowbite/flowbite-button/flowbite-button.component';

@Component({
  selector: 'app-confirm-dialog',
  imports: [MatIconModule, MatDialogModule, MatButtonModule, TranslateModule, FlowbiteButtonComponent],
  templateUrl: './confirm-dialog.component.html',
  styleUrls: ['./confirm-dialog.component.scss'],
})
export class ConfirmDialogComponent {
  constructor(@Inject(MAT_DIALOG_DATA) public data: ConfirmDialogData) {}
}
